@if (company) {
  <div>
    <div class="details-title d-flex flex-row inline-gap-20 align-items-center">
      <h1 class="content-main-title">{{ company.companyName }}</h1>
      <span id="delete-company-dialog-label" class="d-none">{{ 'aria.confirm-delete-dialog' | translate }}</span>
      @if (canEditCompany) {
        <div #deleteModalContainer class="inline-gap-10">
          <app-icon-button class="title-functions"
            element="link"
            [icon]="faEdit"
            [routerLink]="['/admin/companies', company.companyName, 'edit']"
            [state]="company"
            [text]="'content.edit' | translate"
          [tooltip]="'content.edit-something' | translate:{ what:company.companyName }"></app-icon-button>
          <app-icon-button class="title-functions"
            [text]="'content.delete' | translate"
            [tooltip]="'content.delete-something' | translate:{what:company.companyName}"
            [icon]="faTrash"
          (buttonClick)="delete(company, 'delete-company-dialog-label', deleteModalContainer)"></app-icon-button>
        </div>
      }
    </div>
    <div class="pt-4">
      <ul #nav="ngbNav" class="tu-nav-tabbar nav nav-pills" ngbNav role="tablist" [roles]="false" [destroyOnHide]="false" [(activeId)]="activeTabId">
        <li role="tab" [ngbNavItem]="1">
          <a ngbNavLink appAriaAttrsParent [attr.aria-label]="'content.view-the-branches-for-company' | translate:{ companyName:company.companyName }">
            {{ 'content.branches' | translate }}
          </a>
          <ng-template ngbNavContent>
            <app-item-list
              filterFormPlaceholder="123AB12345"
              [addNewRouterLink]="['/admin/companies', company.companyName, 'branches', 'new']"
              [canAddNew$]="guiPermissionsService.canCreateBranches$"
              [addNewRouterState]="{company: company, branch: null}"
              [filterFunction]="branchMatchesFilter"
              [items]="branchesSubject"
              (filteredSortedItems)="filteredSortedBranches = $event">
              <table class="table table-striped">
                <caption>{{ 'content.branches-belonging-to-company' | translate:{companyName: company.companyName} }}</caption>
                <thead>
                  <tr>
                    <th appSortable="branchName" scope="col">{{ 'content.branch-name' | translate }}</th>
                    <th appSortable="memberCode" scope="col">{{ 'content.member-code' | translate }}</th>
                    <th appSortable="product" scope="col">{{ 'content.product' | translate }}</th>
                    @if (canEditCompany) {
                      <th scope="col">{{ 'content.options' | translate }}</th>
                    }
                  </tr>
                </thead>
                <tbody>
                  @for (branch of filteredSortedBranches; track branch) {
                    <tr>
                      <th scope="row">
                        {{ branch.branchName }}
                      </th>
                      <td>{{ branch.memberCode }}</td>
                      <td>{{ branch.product }}</td>
                      @if (canEditCompany) {
                        <td #deleteModalContainer class="inline-gap-3">
                          <app-icon-button element="link"
                            [ariaLabel]="'content.edit-branch' | translate"
                            [icon]="faEdit"
                            [routerLink]="['/admin/companies', company.companyName, 'branches', branch.branchName, 'edit']"
                            [state]="{company: company, branch: branch}"
                          [tooltip]="'content.edit-something' | translate:{what:branch.branchName}"></app-icon-button>
                          <app-icon-button [icon]="faTrash"
                            [ariaLabel]="'content.delete-branch' | translate"
                            [tooltip]="'content.delete-something' | translate:{what:branch.branchName}"
                          (buttonClick)="deleteBranch(branch, 'delete-branch-dialog-label', deleteModalContainer)"></app-icon-button>
                        </td>
                      }
                    </tr>
                  }
                </tbody>
              </table>
              <span id="delete-branch-dialog-label" class="d-none">{{ 'aria.confirm-delete-branch-dialog' | translate }}</span>
            </app-item-list>
          </ng-template>
        </li>
        <li role="tab" [ngbNavItem]="2">
          <a ngbNavLink appAriaAttrsParent [attr.aria-label]="'content.view-administrators-for-company' | translate:{companyName:company.companyName}">{{ 'content.administrators' | translate }}</a>
          <ng-template ngbNavContent>
            <app-user-list [addNewRouterLink]="canCreateCompanyAdmins ? ['/admin/companies', company.companyName, 'add-user', 'admin'] : null"
              [canAddNew$]="guiPermissionsService.canAddCompanyAdmins$"
              [caption]="'content.administrators-for-company' | translate:{companyName:company.companyName}"
              [usersSubject]="administratorsSubject"
            ></app-user-list>
          </ng-template>
        </li>
        <li role="tab" [ngbNavItem]="3">
          <a ngbNavLink appAriaAttrsParent [attr.aria-label]="'content.view-users-for-company' | translate:{companyName:company.companyName}">
            {{ 'content.users' | translate }}
          </a>
          <ng-template ngbNavContent>
            <app-user-list [addNewRouterLink]="['/admin/companies', company.companyName, 'add-user', 'user']"
              [canAddNew$]="guiPermissionsService.canAddUser(company.companyName)"
              [caption]="'content.users-for-company' | translate:{companyName:company.companyName}"
              [usersSubject]="usersSubject"
            ></app-user-list>
          </ng-template>
        </li>
      </ul>
      <div class="mt-2" [ngbNavOutlet]="nav"></div>
    </div>
  </div>
}
@if (companyNotFound) {
  <div>
    {{ 'content.company-not-found' | translate:{companyName: companyNameParam} }}
  </div>
}
